import React from 'react'
import {ACTIONS} from './CustomerOrderList'
import "./CustomerOrderList.css"
import { formatPhoneNumber } from "../../print/page/Print";
function CustomerOrderItem({ orderCustomer, dispatch, disabled }) {
  return (
          <tr className='table-row'>
            <td>{orderCustomer.name}</td>
            <td>{orderCustomer.lastname}</td>
            <td>{formatPhoneNumber(orderCustomer.phone)}</td>
            <td className='cancel-button-table'>
                <button onClick={() => {
                  disabled(false);
                  dispatch({
                    type: ACTIONS.DELETE_CUSTOMER_ITEM,
                    payload: {id: orderCustomer.id}})
                  }}>
                      X
                </button> 
            </td>
          </tr>
  )
}
export default CustomerOrderItem;
